import * as React from "react";
import { useState } from "react";
import { getValueFromInput } from "util/FormsUtils";
import { Input } from "components/bootstrap";
import NumberUtils from "util/NumberUtils";
const SizeBasedRotationStrategyConfiguration = ({
  config,
  updateConfig,
  disabled = false
}) => {
  const { max_size } = config;
  const [maxSize, setMaxSize] = useState(max_size);
  const _onInputUpdate = (field) => (e) => {
    const update = {};
    const value = getValueFromInput(e.target);
    update[field] = value;
    setMaxSize(value);
    updateConfig(update);
  };
  const _formatSize = () => NumberUtils.formatBytes(maxSize);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      disabled,
      type: "number",
      id: "max-size",
      label: "Max size per index (in bytes)",
      onChange: _onInputUpdate("max_size"),
      value: maxSize,
      help: "Maximum size of an index before it gets rotated",
      addonAfter: _formatSize(),
      required: true
    }
  ));
};
export default SizeBasedRotationStrategyConfiguration;
